var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { BAlert } from "bootstrap-vue";
import { computed, ref } from "vue";
import { createFormDataToPayload, createTemplateForm, pluginStatusToErrorMessage, } from "@/components/ConfigTemplates/formUtil";
import { errorMessageAsString } from "@/utils/simple-error";
import { create, test } from "./services";
import InstanceForm from "@/components/ConfigTemplates/InstanceForm.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CreateForm',
    props: {
        template: null
    },
    emits: ["created"],
    setup(__props, { emit }) {
        const props = __props;
        const error = ref(null);
        const title = "Create a new file source for your data";
        const submitTitle = "Submit";
        const loadingMessage = "Loading file source template and instance information";
        const inputs = computed(() => {
            return createTemplateForm(props.template, "file source");
        });
        function onSubmit(formData) {
            return __awaiter(this, void 0, void 0, function* () {
                const payload = createFormDataToPayload(props.template, formData);
                const { data: pluginStatus } = yield test(payload);
                const testError = pluginStatusToErrorMessage(pluginStatus);
                if (testError) {
                    error.value = testError;
                    return;
                }
                try {
                    const { data: fileSource } = yield create(payload);
                    emit("created", fileSource);
                }
                catch (e) {
                    error.value = errorMessageAsString(e);
                    return;
                }
            });
        }
        return { __sfc: true, error, props, title, submitTitle, loadingMessage, inputs, onSubmit, emit, BAlert, InstanceForm };
    }
});
